

// action - state management
import * as actionTypes from './actions';

export const INVESTOR_INVITE_GATE = 50;

export const initialState = {
    progressData: null,
    requiredFields: [],
    completionPercentage: 0,
    round_id: null
}

const progressReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_PROGRESS_DATA:
            return {
                ...state,
                progressData: action?.progressData,
                requiredFields: action?.requiredFields,
                completionPercentage: action?.completionPercentage,
                round_id: action?.round_id,
                // Section weights from the server (admin-managed); null until the first fetch.
                weights: action?.weights ?? state.weights ?? null,
                scoreNotice: action?.scoreNotice ?? null,
                invitesUnlocked: !!action?.invitesUnlocked,
                // Invites open at 50%, and stay open for startups that already reached it.
                canInviteInvestors: (action?.completionPercentage ?? 0) >= INVESTOR_INVITE_GATE || !!action?.invitesUnlocked,
            }
        default:
            return state;
    }
}

export default progressReducer
